export default __webpack_public_path__ + "static/media/doc1.c38932da.jpg";